<div *ngIf="!isLoading && !processing else showLoading" class="cas-scroll">
    <ng-container *ngIf="userName.length > 1">
        <h4 class="user-name">{{userName}}</h4>
    </ng-container>
    <ng-container *ngIf="stepNumber == 1">
        <!-- Start -->
        <ng-container *ngTemplateOutlet="step1"></ng-container>
    </ng-container>
    <ng-container *ngIf="stepNumber == 2">
        <!-- Organisation: details -->
        <ng-container *ngTemplateOutlet="step2"></ng-container>
    </ng-container>
    <ng-container *ngIf="stepNumber == 3">
        <!-- Organisation: contacts -->
        <ng-container *ngTemplateOutlet="step3"></ng-container>
    </ng-container>
    <ng-container *ngIf="stepNumber == 4">
        <!-- User: details -->
        <ng-container *ngTemplateOutlet="step4"></ng-container>
    </ng-container>
    <ng-container *ngIf="stepNumber == 5">
        <!-- Contact: details -->
        <ng-container *ngTemplateOutlet="step5"></ng-container>
    </ng-container>
    <ng-container *ngIf="stepNumber == 6">
        <!-- User & Contact: organisation properties -->
        <ng-container *ngTemplateOutlet="step6"></ng-container>
    </ng-container>
    <ng-container *ngIf="stepNumber == 7">
        <!-- Submitting form -->
        <ng-container *ngTemplateOutlet="submitting"></ng-container>
    </ng-container>
    <ng-container *ngIf="stepNumber == 8">
        <!-- Completed -->
        <ng-container *ngTemplateOutlet="submittedSuccessfully"></ng-container>
    </ng-container>

</div>

<ng-template #step1>
    <!--
        A new contact can be:
          1. an organisation (with or without an email address)
          2. an organisation with contact people
          3. a user with an email who may or may not be registered
          4. a contact we will not invite to the system, who may or may not have an email address
    -->
    <form [formGroup]="stepOneForm">
        <acabim-form-block
            labelWidth="12"
            labelAlign="right"
            [colonize]="true"
            [shortFields]="true">
            <div class="cas-form-block-title" data-cy="_t-add-contact-start-title">{{stepTitles.step1}}</div>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Contact type</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        id="_t-add-contact-type"
                        [options]="contactTypes"
                        optionLabel="label"
                        formControlName="contactType"
                        placeholder="Select type"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Role type</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        id="_t-add-role-type"
                        [options]="roleOptions"
                        optionLabel="label"
                        formControlName="roleType"
                        placeholder="Select role type"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Legal representation?</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-checkbox binary="true" formControlName="isLegalRep"></p-checkbox>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Is this an organisation?</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-checkbox binary="true" formControlName="isEntity"></p-checkbox>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="!isOrganisation">
                <acabim-form-input-label>Belongs to an organisation?</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        [options]="allOrganisations"
                        optionLabel="label"
                        formControlName="memberOf"
                        placeholder="Select organisation"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="!existingContact">
                <acabim-form-input-label>Invite this contact</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-checkbox binary="true" formControlName="selectInvite"></p-checkbox>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="contactInvitation">
                <acabim-form-input-label>Invitation email address</acabim-form-input-label>
                <acabim-form-input-content [longField]="true">
                    <input type="text" formControlName="emailInvite" />
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <div class="cas-action-buttons cas-action-buttons-bottom">
                <button type="button" (click)="onCancel()">Cancel</button>
                <button
                    type="button"
                    class="cas-button-action cas-button-right"
                    data-cy="_t-add-contact-step-1"
                    (click)="step(1)">Next</button>
            </div>
        </acabim-form-block>
    </form>
</ng-template>

<ng-template #step2>
    <!--
        At step two we have an organisation
    -->
    <form [formGroup]="organisationDetailsForm">
        <acabim-form-block
            labelWidth="12"
            labelAlign="right"
            [colonize]="true"
            [shortFields]="true">
            <div class="cas-form-block-title" data-cy="_t-add-contact-step2-title">{{stepTitles.step2}}</div>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Organisation Name</acabim-form-input-label>
                <acabim-form-input-content [longField]="true">
                    <input type="text" formControlName="organisationName">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Legal Name</acabim-form-input-label>
                <acabim-form-input-content [longField]="true">
                    <div>
                        <input type="text" formControlName="legalName">
                        <span
                            *ngIf="!existingContact"
                            class="cas-form-units active same-as-org"
                            data-cy="_t-add-contact-step2-same-as-org"
                            (click)="legalSame()">Same as organisation</span>
                    </div>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="existingContact && existingContact.primary_contact?.user_name">
                <acabim-form-input-label>Primary contact</acabim-form-input-label>
                <acabim-form-input-content>
                    {{existingContact.primary_contact?.user_name}}
                    <input type="hidden" formControlName="memberOfExistingA">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="!existingContact || !existingContact.primary_contact?.user_name">
                <acabim-form-input-label>Add a primary contact?</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-checkbox name="addPrimaryContact" formControlName="addPrimaryContact"></p-checkbox>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <ng-container *ngIf="addPrimaryContact">
                <ng-container *ngIf="members && members.length > 0 else showLoading">
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label>Select from existing</acabim-form-input-label>
                        <acabim-form-input-content>
                            <p-dropdown
                                [options]="members"
                                optionLabel="value"
                                formControlName="memberOfExisting"
                                placeholder="Select contact"></p-dropdown>
                        </acabim-form-input-content>
                    </acabim-form-input-wrapper>
                </ng-container>

                <acabim-form-input-wrapper>
                    <acabim-form-input-label [withLabel]="false"></acabim-form-input-label>
                    <acabim-form-input-content>
                        <p class="push-up-1">Or add a new contact:</p>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>

                <acabim-form-input-wrapper>
                    <acabim-form-input-label>First name</acabim-form-input-label>
                    <acabim-form-input-content [longField]="true">
                        <input type="text" formControlName="primaryContactFirstName">
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Family name</acabim-form-input-label>
                    <acabim-form-input-content [longField]="true">
                        <input type="text" formControlName="primaryContactFamilyName">
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Email address</acabim-form-input-label>
                    <acabim-form-input-content [longField]="true">
                        <input type="text" formControlName="primaryContactEmail">
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </ng-container>

            <acabim-form-input-wrapper *ngIf="invitePrimaryContact">
                <acabim-form-input-label>Invite this contact</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-checkbox name="selectInvite" formControlName="selectInvite"></p-checkbox>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>

        </acabim-form-block>
        <div class="cas-action-buttons cas-action-buttons-bottom">
            <button type="button" (click)="backStep()">Back</button>
            <button type="button" (click)="onCancel()">Cancel</button>
            <button type="button" *ngIf="addPrimaryContact" (click)="step(2, 3)">Add another contact?</button>
            <button
                    type="button"
                    class="cas-button-action"
                    data-cy="_t-add-contact-step-2"
                    (click)="step(2)">Complete</button>
        </div>
    </form>
</ng-template>

<ng-template #step3>
    <!--
        Add another contact to an organisation
    -->
    <form [formGroup]="organisationContactForm">
        <acabim-form-block
            labelWidth="12"
            labelAlign="right"
            [colonize]="true"
            [shortFields]="true">
            <div class="cas-form-block-title">{{stepTitles.step3}} ({{organisationName}})</div>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>First name</acabim-form-input-label>
                <acabim-form-input-content [longField]="true">
                    <input type="text" formControlName="contactFirstName">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Family name</acabim-form-input-label>
                <acabim-form-input-content [longField]="true">
                    <input type="text" formControlName="contactFamilyName">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Email address</acabim-form-input-label>
                <acabim-form-input-content [longField]="true">
                    <input type="text" formControlName="contactEmail">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="!existingContact">
                <acabim-form-input-label>Invite this contact</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-checkbox name="select_invite" formControlName="selectInvite"></p-checkbox>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
        <div class="cas-action-buttons cas-action-buttons-bottom">
            <button type="button" (click)="onCancel()">Cancel</button>
            <button type="button" (click)="step(3, true)">Add another contact?</button>
            <button type="button" class="cas-button-action" (click)="step(3)">Skip</button>
        </div>
    </form>
</ng-template>

<ng-template #step4>
    <!--
        User details
    -->
    <form [formGroup]="userDetailsForm">
    </form>
</ng-template>

<ng-template #step5>
    <!--
        Contact details
    -->
    <form [formGroup]="contactDetailsForm">
        <acabim-form-block
            labelWidth="10"
            labelAlign="right"
            [colonize]="true">
            <div class="cas-form-block-title" data-cy="_t-add-contact-step5-title">{{stepTitles.step5}}</div>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>First name</acabim-form-input-label>
                <acabim-form-input-content [longField]="true">
                    <input formControlName="firstName" type="text">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Family name</acabim-form-input-label>
                <acabim-form-input-content [longField]="true">
                    <input formControlName="familyName" type="text">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Company name</acabim-form-input-label>
                <acabim-form-input-content [longField]="true">
                    <input formControlName="companyName" type="text">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Email address(es)</acabim-form-input-label>
                <acabim-form-input-content class="cas-flex-column">
                    <div class="details-list">
                        <div *ngFor="let email of emails; let i = index" class="details-list-record">
                            <input
                                type="radio"
                                name="defaultEmail"
                                (click)="makeDefaultDetail('email', i)"
                                [checked]="email.default">
                            <div attr.data-cy="_t-email-input-{{i}}">{{email.value}}<span class="cas-form-units">{{email.type | titlecase}}</span></div>
                            <ng-container *ngIf="email.id">
                                <button type="button" (click)="editDetail('email', email)">Edit</button>
                            </ng-container>
                            <button type="button" (click)="deleteDetail('email', i)">Delete</button>
                        </div>
                    </div>
                    <acabim-button-positive data-cy="_t-add-email-button" (callback)="openAddEmail()"></acabim-button-positive>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Phone number(s)</acabim-form-input-label>
                <acabim-form-input-content class="cas-flex-column">
                    <div class="details-list">
                        <div *ngFor="let phone of phones; let i = index" class="details-list-record">
                            <input
                                type="radio"
                                name="defaultPhone"
                                (click)="makeDefaultDetail('phone', i)"
                                [checked]="phone.default">
                            <div attr.data-cy="_t-phone-input-{{i}}">{{phone.value}}<span class="cas-form-units">{{phone.type | titlecase}}</span></div>
                            <ng-container *ngIf="phone.id">
                                <button type="button" (click)="editDetail('phone', phone)">Edit</button>
                            </ng-container>
                            <button type="button" (click)="deleteDetail('phone', i)">Delete</button>
                        </div>
                    </div>
                    <acabim-button-positive data-cy="_t-add-phone-button" (callback)="openAddPhone()"></acabim-button-positive>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
        <div class="cas-action-buttons cas-action-buttons-bottom">
            <button type="button" (click)="backStep()">Back</button>
            <button type="button" (click)="onCancel()">Cancel</button>
            <button
                type="button"
                class="cas-button-action"
                data-cy="_t-add-contact-step-5"
                (click)="step(5)">Next</button>
        </div>
        <acabim-modal [title]="'Email address'" [display]="displayAddEmailModal" (status)="handleDetailClose($event)">
            <acabim-admin-add-email detailType="email" (submit)="handleAdd($event)" [existing]="editEmail"></acabim-admin-add-email>
        </acabim-modal>
        <acabim-modal [title]="'Phone number'" [display]="displayAddPhoneModal" (status)="handleDetailClose($event)">
            <acabim-admin-add-email detailType="phone" (submit)="handleAdd($event)" [existing]="editPhone"></acabim-admin-add-email>
        </acabim-modal>
    </form>
</ng-template>

<ng-template #step6>
    <!--
        User and contact organisation properties
    -->
    <form [formGroup]="contactOrganisationPropertiesForm">
        <acabim-form-block
                labelWidth="10"
                labelAlign="right"
                [colonize]="true">
            <div class="cas-form-block-title" data-cy="_t-add-contact-step6-title">{{stepTitles?.step6}}</div>
            <ng-container
                formArrayName="organisationInputs"
                *ngFor="let item of organisationProperties; let i = index">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>{{item | titlecase}}</acabim-form-input-label>
                    <acabim-form-input-content [longField]="true">
                        <input
                           [formControlName]="i"
                           type="text"
                           attr.data-cy="_t-add-contact-add-det-{{i}}">
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </ng-container>
            <ng-container formArrayName="organisationCheckboxes" *ngFor="let attribute of organisationAttributes; let i = index">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>{{attribute | titlecase}}</acabim-form-input-label>
                    <acabim-form-input-content [longField]="true">
                        <input [formControlName]="i" type="checkbox">
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </ng-container>
        </acabim-form-block>
        <div class="cas-action-buttons cas-action-buttons-bottom">
            <button type="button" (click)="backStep()">Back</button>
            <button type="button" (click)="onCancel()">Cancel</button>
            <button type="button"
                class="cas-button-action"
                data-cy="_t-add-contact-step-6"
                (click)="step(6)">Complete</button>
        </div>
    </form>
</ng-template>

<ng-template #showLoading>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<ng-template #submitting>
    <div class="cas-info">
        <acabim-loading-view></acabim-loading-view>
        <p>{{success.present}} contact …</p>
    </div>
</ng-template>

<ng-template #submittedSuccessfully>
    <div class="cas-info">
        <p data-cy="_t-all-done-message">Successfully {{success.past}} contact!</p>
        <button class="cas-button-action all-done" data-cy="_t-all-done" (click)="onDone()">Ok</button>
    </div>
</ng-template>

<p-toast position="center" key="addContact"></p-toast>
